<template>
    <div class="container">
            <div class="seach-container">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">银行名称</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入关键字"
                            ></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">状态</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.state" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="不生效" value="1"></el-option>
                                <el-option label="生效" value="2"></el-option>
                            </el-select>
                            </div>
                        </div>
                    </div>   
                     <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  icon="el-icon-delete" size="mini" @click="handleEmpty">清空</el-button>
                        </div>
                    </div>
            </div>
            <div class="addBtn">
                 <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button> 
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                 <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.$index, scope.row)">修改</el-button>
                                 <el-button
                                 icon="el-icon-info"
                                size="mini"
                                type="info"
                                @click="handleAccount(scope.row.BankID)">账号</el-button>
                            </div>
                            <div v-else-if="(scope.column.property==='State')">
                                {{ scope.row.State==1?"不生效":"生效" }}
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
          <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
             <!-- 详情弹出框 -->
        <el-dialog :title="type=='add'?'新增银行' : '修改银行'" v-model="detailVisible" width="1000px" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="160px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="银行名称：">
                             <el-input
                                v-model="dataDetail.BankName"
                                size="small"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="营业执照号：">
                             <el-input
                                v-model="dataDetail.FDDCode"
                                size="small"
                                placeholder="请输入营业执照号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="银行初审：">
                        <el-select
                          v-model="FirstUserIDs"
                          multiple
                          size="small"
                          clearable
                          placeholder="请选择"
                          style="width: 590px;"
                        >
                            <el-option
                              v-for="item in userList"
                              :key="item.UserID"
                              :label="item.UserName"
                              :value="item.UserID"
                            />
                        </el-select>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="银行复审：">
                            <el-select v-model="dataDetail.SecondUserID" size="small" placeholder="请选择"
                           >
                            <el-option value="" ></el-option>
                                    <el-option :label="user.UserName" :value="user.UserID" :key="user.UserID" v-for="user in userList"></el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="银行终审：">
                            <el-select v-model="dataDetail.ThirdUserID" size="small" placeholder="请选择"
                            >
                            
                                      <el-option value="" ></el-option>
                                    <template v-for="user in userList" :key="user.UserID">
                                        <el-option :label="user.UserName" :value="user.UserID"  ></el-option>
                                    </template>
                                </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                                                <el-row>
                    <el-col :span="11">
                        <el-form-item label="经办人姓名：">
                             <el-input
                                v-model="dataDetail.ActUserName"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="经办人法大大号：">
                             <el-input
                                v-model="dataDetail.ActFddCode"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="银行法大大号：">
                             <el-input
                                v-model="dataDetail.BankFDDCode"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                                <el-row>
                    <el-col :span="11">
                        <el-form-item label="内部账户名称：">
                             <el-input
                                v-model="dataDetail.NBZHHM"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="内部账户开户行：">
                             <el-input
                                v-model="dataDetail.NBZHKHH"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                                <el-row>
                    <el-col :span="11">
                        <el-form-item label="内部账户账号：">
                             <el-input
                                v-model="dataDetail.NBYHZH"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="转贷专户名称：">
                             <el-input
                                v-model="dataDetail.ZDZHHM"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                                                <el-row>
                    <el-col :span="11">
                        <el-form-item label="转贷专户开户行：">
                             <el-input
                                v-model="dataDetail.ZDZHKHH"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="转贷专户账号：">
                             <el-input
                                v-model="dataDetail.ZDZHZH"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                                      <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="转贷营业部行号：">
                             <el-input
                                v-model="dataDetail.ZDYYBHH"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                                                <el-row>
                    <el-col :span="11">
                        <el-form-item label="使用费率(‰)：">
                             <el-input
                                v-model="dataDetail.SYFL"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="1"> </el-col>
                    <el-col :span="11">
                        <el-form-item label="逾期费率(‰)：">
                             <el-input
                                v-model="dataDetail.YQFL"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                                                       <el-row>
                    <el-col :span="11">
                        <el-form-item label="违约费率(‰)：">
                             <el-input
                                v-model="dataDetail.WYFL"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="1"> </el-col>
                    <el-col :span="11">
                           <el-form-item label="转贷工作日：">
                             <el-input
                                v-model="dataDetail.WorkDayNum"
                                size="small"
                                placeholder="请输入默认值"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                   <el-row>
                    <el-col :span="11">
                            <el-form-item label="状态：">
                               <el-select v-model="dataDetail.State" size="small" placeholder="请选择" >
                                    <el-option label="不生效" value="1"></el-option>
                                    <el-option label="生效" value="2"></el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="11">
                            <el-form-item label="是否免签：">
                               <el-select v-model="dataDetail.IsFreeSign" size="small" placeholder="请选择" >
                                    <el-option label="否" value="0"></el-option>
                                    <el-option label="是" value="1"></el-option>
                                </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="detailVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addOrUpdateBank">提交</el-button>
                </div>
        </el-dialog>
         <v-account :isShow="accountVisible" :bankId="bankId" flag="1" @transfer="getAccount"></v-account>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
.dialog-Btn{
    text-align: center;
}
</style>